import { AppState } from '@/redux';
import { getButtonCount } from '@/redux/selectors/app';
import { useSelector } from 'react-redux';
import styled, { css, DefaultTheme } from 'styled-components';

export default styled.div`
  ${({ theme }: { theme: DefaultTheme }) => {
    const buttonCount = useSelector<AppState, number>(getButtonCount);

    return css`
      position: absolute;

      &[data-position='TopLeft'],
      &[data-position='CenterLeft'],
      &[data-position='TopRight'],
      &[data-position='CenterRight'] {
        @media ${theme.mq.max.tablet} {
          top: 4.5em;
          left: ${buttonCount === 6 ? '6.5em' : '4em'};
        }
      }

      &[data-position='BottomLeft'],
      &[data-position='BottomRight'] {
        @media ${theme.mq.max.tablet} {
          bottom: 4.5em;
          left: ${buttonCount === 6 ? '6.5em' : '4em'};
        }
      }

      &[data-position='TopLeft'] {
        @media ${theme.mq.min.tablet} {
          top: ${buttonCount === 6 ? '10.5em' : '7.5em'};
          left: 0;
        }
      }

      &[data-position='CenterLeft'] {
        @media ${theme.mq.min.tablet} {
          top: ${buttonCount === 6 ? '10.5em' : '7.5em'};
          left: 0;
        }
      }

      &[data-position='BottomLeft'] {
        @media ${theme.mq.min.tablet} {
          bottom: 10.75em;
          left: 0;
        }
      }

      &[data-position='TopRight'] {
        @media ${theme.mq.min.tablet} {
          top: ${buttonCount === 6 ? '10.5em' : '7.5em'};
          right: 0;
        }
      }

      &[data-position='CenterRight'] {
        @media ${theme.mq.min.tablet} {
          top: ${buttonCount === 6 ? '10.5em' : '7.5em'};
          right: 0;
        }
      }

      &[data-position='BottomRight'] {
        @media ${theme.mq.min.tablet} {
          bottom: 10.75em;
          right: 0;
        }
      }
    `;
  }};
`;
